import * as React from 'react';
import {
  Chip, createStyles, DialogActions, Theme, WithStyles, withStyles,
} from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
// @ts-ignore
import Plot from 'react-plotly.js';
// @ts-ignore
import CancelButton from 'hcla-web-frontend-primitives/app/components/primitives/Buttons/CancelButton';

import Grid from '@material-ui/core/Grid';
import { NodeLabel } from '../NodeLabel/NodeLabel';
import { QRLabelMapJSON } from '../../Quantification/QuantificationResultJSON';

const styles = createStyles({
  rowItem: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
});


export interface PointEstimateTTFChipProps extends WithStyles<typeof styles> {
  data: Array<number[]>;
  dialogProps?: DialogProps;
  map: QRLabelMapJSON;
  name: string;
  theme: Theme;
}

interface State {
  portalOpen: boolean;
}

class PointEstimateTTFChip extends React.Component<PointEstimateTTFChipProps, State> {
  private readonly nodeLabel: NodeLabel;

  private readonly x: number[] = [];

  private readonly y: number[] = [];

  private max = 0;

  constructor(props: PointEstimateTTFChipProps) {
    super(props);
    this.state = {
      portalOpen: false,
    };
    const { map, name, data } = props;
    data.forEach((tuple) => {
      if (tuple[0] || tuple[1]) {
        this.x.push(tuple[0]);
        this.y.push(tuple[1]);
        if (tuple[1] > this.max) {
          this.max = tuple[1];
        }
      }
    });
    this.nodeLabel = NodeLabel.buildWithDefaults(map, name);
  }

  private handleClose = (e: React.SyntheticEvent<{}, Event>) => {
    this.setState({ portalOpen: false });
  };

  private handleOpen = (e: React.SyntheticEvent<{}, Event>) => {
    this.setState({ portalOpen: true });
  };

  render() {
    const { portalOpen } = this.state;
    const { dialogProps, classes: { rowItem }, theme } = this.props;
    const { label: { name, description } } = this.nodeLabel;
    return (
      <React.Fragment>
        <div className={rowItem}>
          <Chip
            variant="default"
            color="secondary"
            label={(this.max).toExponential(3)}
            onClick={this.handleOpen}
          />
        </div>
        <Dialog
          {...dialogProps}
          open={portalOpen}
          fullWidth
          maxWidth="md"
          onClose={this.handleClose}
          disablePortal
        >
          <DialogTitle>
            <Grid
              container
              alignItems="center"
              justify="space-between"
            >
              <Grid item>
                <Typography variant="h5" color="textPrimary">{name}</Typography>
                <Typography variant="subtitle1" color="textSecondary">{description}</Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <Plot
              style={{ width: '100%' }}
              config={{
                displaylogo: false,
                autosizable: true,
                responsive: true,
              }}
              data={
                [
                  {
                    x: this.x,
                    y: this.y,
                    type: 'scatter',
                    name: 'Samples',
                    mode: 'lines+markers',
                  },
                ]
              }
              layout={{
                paper_bgcolor: 'transparent',
                plot_bgcolor: 'transparent',
                font: {
                  color: theme.palette.text.primary,
                  family: theme.typography.fontFamily,
                  size: theme.typography.fontSize,
                },
                title: 'Time to Failure',
                xaxis: {
                  color: theme.palette.text.secondary,
                  title: 'Time',
                  gridcolor: theme.palette.text.secondary,
                  type: 'linear',
                  autorange: true,
                },
                yaxis: {
                  title: 'Probability',
                  color: theme.palette.text.secondary,
                  gridcolor: theme.palette.text.secondary,
                  type: 'linear',
                  autorange: true,
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <CancelButton
              variant="outlined"
              onClick={this.handleClose}
              size="large"
            >
              Close
            </CancelButton>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(PointEstimateTTFChip);
